import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./auth";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { SetPasswordPage } from "./pages/SetPasswordPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ItemPage } from "./pages/ItemPage";
import { LoansPage } from "./pages/LoansPage";
import { HistoryPage } from "./pages/HistoryPage";
import { AlertsPage } from "./pages/AlertsPage";
import { UsersPage } from "./pages/UsersPage";
import { QrPage } from "./pages/QrPage";
import { InventoryAdminPage } from "./pages/InventoryAdminPage";

function Protected({ children, admin = false }: { children: React.ReactNode; admin?: boolean }) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="splash"><span className="spinner" />Chargement du stock…</div>;
  if (!session) {
    sessionStorage.setItem("stock-return-to", `${location.pathname}${location.search}`);
    return <Navigate to="/login" replace />;
  }
  const mustChangePassword = session.user.app_metadata?.must_change_password
    ?? session.user.user_metadata?.must_change_password;
  if (mustChangePassword) {
    return <Navigate to="/set-password" replace />;
  }
  if (!profile?.active) return <div className="splash">Ce compte est désactivé. Contactez un administrateur.</div>;
  if (admin && profile.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/" element={<Protected><DashboardPage /></Protected>} />
      <Route path="/item/:id" element={<Protected><ItemPage /></Protected>} />
      <Route path="/loans" element={<Protected><LoansPage /></Protected>} />
      <Route path="/history" element={<Protected><HistoryPage /></Protected>} />
      <Route path="/alerts" element={<Protected><AlertsPage /></Protected>} />
      <Route path="/qr" element={<Protected admin><QrPage /></Protected>} />
      <Route path="/users" element={<Protected admin><UsersPage /></Protected>} />
      <Route path="/admin/items" element={<Protected admin><InventoryAdminPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
